import React, { useState, useEffect } from "react";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { toast } from "react-toastify";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import MuiComboBox from "../../../shares/MuiComboBox";
import MuiButton from "../../../shares/MuiButton";

const ChangeCustomer = (props) => {
  const { userData } = useUserData();

  const [selectedCustomer, setSelectedCustomer] = useState(undefined);

  const [openModal, setOpenModal] = useState(false);

  const [searchedCustomerText, setSearchedCustomerText] = useState("");
  const [adminCustomersList, setAdminCustomersList] = useState({
    results: [],
  });

  const getListOfCustomerApi = useFetch({
    method: "post",
    url: `User_Service/${userData.username}/admin_search_user`,
    data: { user: searchedCustomerText },
    argFunc: (res) => {
      setAdminCustomersList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const createLog = useFetch({
    method: "post",
    url: `Order_Service/${props.selectedRow?.id}/create_order_log`,
    data: { state: "order_change_customer" },
    argFunc: (res) => {},
    errMessage: (mess) => {},
  });

  const handleSearchedCustomerText = (text) => {
    setSearchedCustomerText(text);
    if (text.length >= 1) {
      getListOfCustomerApi.reFetch();
    }
  };

  const updateCustomerApi = useFetch({
    method: "patch",
    url: `Order_Service/${props.selectedRow?.id}`,
    trigger: false,
    data: {
      creator: selectedCustomer,
    },
    argFunc: (res) => {
      setOpenModal(false);
      createLog.reFetch();
      props.adminGetCustomerCreateOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <TableIconModal
        width="w-1/2"
        icon={<ChangeCircleIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div className="grid md:grid-cols-3 gap-x-4 items-center mt-4">
          <span className="">مشتری را انتخاب کنید:</span>
          <MuiComboBox
            size="small"
            label="مشتری"
            labelId="customer-search-label"
            id="customer-search-select"
            options={adminCustomersList.results}
            placeholder="نام مشتری"
            setSelectedOption={setSelectedCustomer}
            setSearchText={handleSearchedCustomerText}
            forUser
            baseUsername
            isCustomer
          />
          <MuiButton
            onClick={() => updateCustomerApi.reFetch()}
            variant="contained"
            icon=<ChangeCircleIcon />
            color="primary"
            text="تایید"
            disabled={selectedCustomer == undefined}
          />
        </div>
      </TableIconModal>
    </>
  );
};

export default ChangeCustomer;
